import { RESET_PAGES } from '../constants/action_types/reset'

export const resetPagesData = dispatch => {
  RESET_PAGES.forEach(actionType => dispatch({ type: actionType }))
}
